<div class="dashInfoBox">
  <div>
    <span class="dashInfoHeading" [innerHTML]="head"></span>
    <span class="dashInfoContent" [innerHTML]="title"></span>
  </div>
  <div>
    <button type="button" [innerHTML]="btnName" (click)="btnClick.emit()"></button>
  </div>
</div>
